<div class="container" loading-spin [isLoading]="isLoading" [loadingSize]="'big'">
    <thread-detail [config]="threadDetailConfig"></thread-detail>
    <tam-map-tile-dialog></tam-map-tile-dialog>
</div>